import { useRouterHistory } from 'react-router';
import { createHashHistory } from 'history';
import { syncHistoryWithStore } from 'react-router-redux'

let history = useRouterHistory(createHashHistory)({ queryKey: false });

export const initHistory = (store) => {
    history = syncHistoryWithStore(history, store);
};

export {
    history
};



// WEBPACK FOOTER //
// ./app/entry/history.js